<template>
  <b-modal id="totalmarks" centered hide-footer hide-header @hidden="$bvModal.hide('totalmarks')">
    <div class="total-marks-box">
      <div
        class="
          viewmark-heading
          pl-2
          pr-2
          pt-3
          pb-3
          d-flex
          align-items-center
          justify-content-between
        "
      >
        View Marks
      </div>
      <div class="xMarkCancel" @click="$bvModal.hide('totalmarks')">
        <img src="../../../assets/xmark.svg" alt="" />
      </div>
      <hr class="m-0" />
      <div class="p-2 viewmarkmodalheight">
        <div class="viewmark-testbox">
          <div class="viewmark-testbox-headtestname">Test Name</div>
          <div class="viewmark-testbox-subtestname">
            {{ marksdetailsSuccess.testName }}
          </div>
        </div>
        <div
          v-for="(item, index) in marksdetailsSuccess.assessmentResponse"
          :key="index"
          class="viewmark-attempt-open-box mt-3"
        >
          <div
            class="
              viewmark-open-atmpt-box
              d-flex
              align-items-center
              justify-content-between
              pointer
            "
            @click="closemarksSuccess(index)"
          >
            <div class="viewmark-attempt-txt">Attempt {{ item.attemptNo }}</div>
            <div v-if="!item.viewdetails">
              <img
                src="../../../assets/img/viewmarksmodal/downarrow.svg"
                alt=""
              />
            </div>
            <div v-else>
              <img
                src="../../../assets/img/viewmarksmodal/uparrow.svg"
                alt=""
              />
            </div>
          </div>
          <div v-if="item.viewdetails" class="p-2">
            <div class="d-flex align-items-center justify-content-between m-2">
              <div class="sched-viewmark-date-txt">
                Start Date : {{ item.startTime.slice(0, 10) | formatdate }}
              </div>
              <div class="sched-viewmark-date-txt">
                End Date : {{ item.endTime.slice(0, 10) | formatdate }}
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between m-2">
              <div class="">
                <span class="sched-viewmark-section-txt">Duration : </span
                ><span class="sched-viewmark-duration">
                  {{ ("0" + item.duration.slice(0, 7)).slice(-8) }}(HH:MM:SS)
                </span>
              </div>
              <div>
                <span class="sched-viewmark-section-txt">Result : </span>
                <span
                  :class="
                    item.status == 'Fail'
                      ? 'viewmark-fail-txt'
                      : 'viewmark-pass-txt'
                  "
                  >{{ item.status }}</span
                >
              </div>
              <!-- For fail text -->
            </div>
            <div class="viewmark-marks-container m-2">
              <div class="d-flex align-items-center justify-content-between">
                <div class="viewmark-section-txt">
                  <img
                    src="../../../assets/img/viewmarksmodal/view result.svg"
                    class="mr-2"
                    alt=""
                  />
                  Marks
                </div>
                <div class="">
                  <span class="viewmark-section-txt">Total Marks : </span
                  ><span class="viewmark-duration"
                    >&nbsp;{{ item.marksScored }} /
                    {{ item.totalTestMarks }}</span
                  >
                </div>
              </div>

              <hr />
              <div v-for="(sec, index) in item.sections" :key="index">
                <div
                  class="d-flex align-items-center justify-content-between mt-1"
                >
                  <div class="viewmark-section-txt">
                    {{ sec.sectionName }}
                  </div>
                  <div class="viewmark-mark-txt" style="color: #3f698e">
                    {{ sec.sectionMarksScored }} / {{ sec.sectionMarksTotal }}
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { closemarksSuccess } from "../../../controllers/JD/asynchronous.js";
export default {
  name: "ViewmarkModal",
  props: {
    marksdetailsSuccess: Object,
  },
  filters: {
    formatdate(data) {
      let datasplit = data.split("-");
      let datarev = datasplit.reverse();
      let datajoin = datarev.join("-");
      return datajoin;
    },
  },

  methods: {
    closemarksSuccess(index) {
      closemarksSuccess(this, index);
    },
  },
};
</script>
